import { TSlackDataSnippetProps } from "./types/TSlackDataSnippetProps";
import { Typography } from "@mui/material";

const SlackDataSnippet = (props: TSlackDataSnippetProps) => {
  return <Typography># {props.data?.channelName}</Typography>;
};

export default SlackDataSnippet;
